import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import 'jquery';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPlus, faSpinner, faUser, faAlignLeft, faDownload } from '@fortawesome/free-solid-svg-icons';
library.add(faPlus, faSpinner, faAlignLeft, faUser, faDownload);
import VueBlocksTree from 'vue3-blocks-tree';
import 'vue3-blocks-tree/dist/vue3-blocks-tree.css';
import i18n from '@/i18n';
import mitt from 'mitt'
const emitter = mitt();


const app = createApp(App).use(i18n)
app.provide('emitter', emitter)
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('blocks-tree', VueBlocksTree)
app.use(router).mount('#app');

